const e="loading",d="loaded",o="applied",r="entered",a="error",n="native";export{o as statusApplied,r as statusEntered,a as statusError,d as statusLoaded,e as statusLoading,n as statusNative};
